import React from 'react';
import { connect, DispatchProp } from 'react-redux';

import { CharacterTheme, rulesEngineSelectors } from '@dndbeyond/character-rules-engine/es';

import MobileDivider from '../../../components/MobileDivider';
import SubsectionMobile from '../../../components/SubsectionMobile';
import { SheetAppState } from '../../../typings';
import Description from '../../Description';

interface Props extends DispatchProp {
    theme: CharacterTheme;
}
class DescriptionMobile extends React.PureComponent<Props> {
    render() {
        const { theme } = this.props;

        return (
            <SubsectionMobile className="ct-description-mobile">
                <MobileDivider label="Description" theme={theme} />
                <Description theme={theme} isVertical={true} />
                <MobileDivider isEnd={true} theme={theme} />
            </SubsectionMobile>
        );
    }
}

function mapStateToProps(state: SheetAppState) {
    return {
        theme: rulesEngineSelectors.getCharacterTheme(state),
    };
}

export default connect(mapStateToProps)(DescriptionMobile);
